const ActiveSectionActions = {
    SCROLL: "*active-section/scroll",
    JUMP_TO_SECTION: "*active-section/jump-to-section",
};

export default ActiveSectionActions;



// WEBPACK FOOTER //
// ./app/data/ActiveSectionActions.js